import React, { useEffect, useMemo, useState } from 'react';
import { RadioProps } from '@navi/web-ui/lib/primitives/Radio/types';
import { Radio } from '@navi/web-ui/lib/primitives';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import dayjs from 'dayjs';
import { formatToStandardTimeInHours } from '@cp/src/utils/DateHelper';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

const CustomRadio = React.forwardRef<HTMLInputElement, RadioProps>((Props, ref) => {
  const getCallingWindowStartTime = useSelector(
    (store: RootState) => store?.common?.callingWindow?.callingStartTime
  );

  const isPostMidnight = useMemo(() => {
    const time = dayjs(new Date());
    const hour = time.hour();
    return hour >= 12;
  }, []);

  return (
    <>
      <Tooltip>
        <TooltipTrigger>
          <Radio {...Props} ref={ref} />
        </TooltipTrigger>
        <TooltipContent className="tooltipWrapper">
          {`Feedback for calls available from  
                        ${formatToStandardTimeInHours(getCallingWindowStartTime)} 
                        ${isPostMidnight ? 'tomorrow' : 'today'}`}
        </TooltipContent>
      </Tooltip>
    </>
  );
});

export default React.memo(CustomRadio);
